import { host_haiji_url } from '@/api/host'
var feedbackApi = {
  /**
   * 反馈列表
   */
  addRemark: `${host_haiji_url}/v1/admin/user_feedbacks/process/`, //客服处理用户反馈  http://projectdoc.epetbar.com/index.php?s=/177&page_id=3997
  getList: `${host_haiji_url}/v1/admin/user_feedbacks`, //获取用户反馈列表 http://projectdoc.epetbar.com/index.php?s=/177&page_id=3979
  exportFeedBackUrl: `${host_haiji_url}/v1/admin/user_feedbacks/export`,//获取用户反馈列表导出 http://projectdoc.epetbar.com/web/#/177?page_id=4613
  /**
   * 核算用户反馈列表
   */
  getShopList: `${host_haiji_url}/v2/public/consumer/feedback/shop`,//获取优惠券关联店铺
  getHeFeedBackUrl: `${host_haiji_url}/v2/public/consumer/feedback`,//获取核算用户反馈列表
  addHeRemark: `${host_haiji_url}/v2/public/consumer/feedback/`,//添加核销反馈备注
}

export { feedbackApi }
